import React from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Button } from 'reactstrap';

import { browserHistory } from 'react-router';

import Link from 'gatsby-link';

import Logo from '../assets/logo.svg';
import HomeIcon from '../assets/icon/home.svg';
import FolderIcon from '../assets/icon/folder.svg';
import ArchitecteIcon from '../assets/icon/architecte.svg';

class Header extends React.Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  componentWillMount() {
    this.props.history.listen(() => {
      this.setState({
        isOpen: false
      });
    });
  }

  render() {
    return (
      <Navbar color="faded" light expand="xl" className="fixed-top">
        <NavbarBrand href="/">
          <img src={Logo} alt="Didier Bré — Artisan menuisier" style={{
            padding: '10px 0'
          }} />
        </NavbarBrand>
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={this.state.isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <Link to="/" className="nav-link mt-4 mt-xl-0 mb-2 mb-xl-0 mb-xl-0">
                <img src={HomeIcon} alt="Accueil" />
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/atelier" className="nav-link mt-4 mt-xl-0 mb-2 mb-xl-0 mb-xl-0">
                L'atelier
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/expertise" className="nav-link mt-4 mt-xl-0 mb-2 mb-xl-0">
                Nos expertises
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/realisations" className="nav-link mt-4 mt-xl-0 mb-2 mb-xl-0">
                Nos réalisations
              </Link>
            </NavItem>
            <NavItem className="nav-link-space">
              <Link to="/contact" className="nav-link mt-4 mt-xl-0 mb-2 mb-xl-0 mb-xl-0">
                Contact
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/projet" className="mt-4 mt-xl-0 mb-2 mb-xl-0 mb-xl-0">
                <Button color="primary">
                  J'ai un projet <img src={FolderIcon} role="presentation" />
                </Button>
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/architecte" className="mt-4 mt-xl-0 mb-5 mb-xl-0">
                <Button color="secondary">
                  Je suis architecte <img src={ArchitecteIcon} role="presentation" />
                </Button>
              </Link>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    )
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js